import React from 'react'

import { CompanyBrief } from '../../../api/companies/types'
import CompanyCard from './Card'
import Loading from '../layout/Loading'
import NoResults from '../layout/NoResults'

type Props = { data: Array<CompanyBrief> | undefined, isLoading: boolean, error: Error | undefined }
const SmallGrid: React.FC<Props> = ({ data, isLoading, error }) => {
  if(isLoading) return <Loading />
  if(error) return <div>{error.message}</div>
  if(!data || data.length === 0) return <NoResults />
  return (
    <div className='grid grid-cols-2 gap-4'>
      {data.map((company, index) => {
        const isSmall = index % 3 !== 0
        return (
          <div key={company.name} className={isSmall ? '' : 'row-span-2'}>
            <CompanyCard small={isSmall} id={company.id} logoSrc={company.logoSrc} name={company.name} industry={company.industry.name} sector={company.industry?.sector?.name} flagSrc={company.country.flagSrc} isPartner={company.isPartner}/>
          </div>
        )
        })
      }
    </div>
  )
}

export default SmallGrid
